module.exports = __webpack_public_path__ + "img/2-4.9f79ca94.svg";